import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["aria-checked", "aria-label", "aria-selected", "aria-disabled", "ariaLabel", "onClick", "onPress", "style", "tabIndex", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { sanitizeProps } from '@bubble-ui/util-sanitize-props';
var normalizeStyle = style => {
  var {
    lineHeight
  } = style;
  return lineHeight ? _objectSpread(_objectSpread({}, style), {}, {
    lineHeight: "".concat(lineHeight, "px")
  }) : style;
};
var Touchable = _ref => {
  var {
      'aria-checked': ariaChecked,
      'aria-label': ariaLabel,
      'aria-selected': ariaSelected,
      'aria-disabled': ariaDisabled,
      ariaLabel: ariaLabelDeprecated,
      onClick,
      onPress,
      style,
      tabIndex,
      type = 'button'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var onClickOrPress = onClick || onPress;
  var normalizedStyle = normalizeStyle(style);
  var restProps = sanitizeProps('Touchable', props, ['accessible',
  // @ts-expect-error
  'accessibilityLabel', 'accessibilityRole', 'accessibilityState', 'hitSlop',
  // @ts-expect-error
  'onPress', 'testID'],
  // if turned true, you'll get warnings on a11y props
  // specially those passed through TouchableIcon
  false);
  return /*#__PURE__*/React.createElement("button", _extends({
    "aria-checked": ariaChecked,
    "aria-disabled": ariaDisabled,
    "aria-label": ariaLabel || ariaLabelDeprecated,
    "aria-selected": ariaSelected,
    style: _objectSpread(_objectSpread({
      padding: 0,
      margin: 0
    }, normalizedStyle), {}, {
      outline: 'none'
    }),
    onClick: onClickOrPress,
    tabIndex: tabIndex,
    type: type
  }, restProps));
};
export { Touchable };
//# sourceMappingURL=index.js.map